import { Injectable, inject } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { ParsedUrl } from '@frontend/vanilla/core';
import { LanguageSwitcherUrlsProvider } from '@frontend/vanilla/features/language-switcher';
import { Observable, map } from 'rxjs';

interface UrlResponse {
    data: Record<string, string>;
}

@Injectable({ providedIn: 'root' })
export class PrettyUrlLanguageSwitcherProvider implements LanguageSwitcherUrlsProvider {
    private api = inject(ApiService);

    getUrls(url: ParsedUrl, languages: string[]): Observable<Map<string, string>> {
        return this.api
            .get<UrlResponse>('url', {
                url: url.url(),
                sourceLanguage: url.culture,
                targetLanguages: languages.join(','),
            })
            .pipe(map((result) => new Map(Object.entries(result.data))));
    }
}
